import createCollectionResource from 'src/actions/shared/createResource';
import { DomainError as StandardDomainError } from '@ad-scripts/application/lib/error';
import { translateErrors } from 'src/adapters/validateType';

interface RuleSet {
  id: string;
}

export enum RuleSetType {
  Automation = 'AUTOMATION',
  SmartMatch = 'SMART_MATCH',
}

const ruleSetsResource = createCollectionResource<RuleSet>({
  name: 'ruleSets',
  endpoint: 'v1/orgs/:orgId/rulesets',
  options: {
    toastMessages: {
      onAddFail: (attrs, err) => getErrorToastMessage(err),
    },
  },
});

export default ruleSetsResource;

export const getErrorToastMessage = (err: any) => {
  if (err instanceof StandardDomainError) {
    const domainErrors = translateErrors(err.errors);
    if (domainErrors.length > 0) {
      const error = domainErrors[0];
      if (error.attr === 'status' && error.code === 'taken') {
        return 'Previous changes are still being applied. Try again later.';
      }
    }
  }
  return 'There was an error while adding';
};
